export default {
  label: {
    savingCapacityMonthly: "Capacité d'épargne mensuelle",
    precautionarySavingsAvailableSavings: 'Épargne disponible',
    precautionarySavingsTheoreticalPrecautionarySavingAmount:
      'Épargne de précaution',
    loanCapacityAmount: "Capacité d'emprunt",
    debtRate: "Taux d'endettement",
  },
}
